import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Sidebar from "../Components/Sidebar";
import Header from "../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { getAllCMS } from "../actions/admin";
import AddCmsModal from "../Modals/AddCmsModal";
import EditCmsModal from "../Modals/EditCmsModal";

const Cms = () => {
  const [cmsList, setCmsList] = useState([]);
  const [showEditCms, setShowEditCms] = useState(false);
  const [showAddCms, setShowAddCms] = useState(false);
  const [editRecord, setEditRecord] = useState({});
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);

  const getCMSData = async () => {
    try {
      const reqData = { page: pageNumber, limit };
      const { status, result, count } = await getAllCMS(reqData);
      if (status === "success") {
        setCmsList(result);
        setCount(count);
      }
    } catch (err) {
      console.error("Error fetching CMS:", err);
    }
  };

  const handlePagination = async (index) => {
    const reqData = { page: index.page_number, limit: index.page_size };
    setPageNumber(index.page_number);
    setLimit(index.page_size);
    const { status, result, count } = await getAllCMS(reqData);
    if (status === "success") {
      setCmsList(result);
      setCount(count);
    }
  };

  useEffect(() => {
    getCMSData();
  }, []);

  const handleShowAddCms = () => setShowAddCms(true);
  const handleCloseAddCms = () => setShowAddCms(false);

  const handleShowEditCms = (record) => {
    setEditRecord(record);
    setShowEditCms(true);
  };

  const handleCloseEditCms = () => {
    setEditRecord({});
    setShowEditCms(false);
  };

  const columns = [
    // Section 1
    {
      key: "section1.description",
      text: "Section 1 Description",
      align: "center",
      className: "exchange_table_values text-center",
      sortable: false,
      cell: (record) => record?.section1?.description || "-",
    },

    // Section 2
    {
      key: "section2.title",
      text: "Section 2 Title",
      align: "center",
      sortable: false,
      cell: (record) => record?.section2?.title || "-",
    },
    {
      key: "section2.description",
      text: "Section 2 Description",
      align: "center",
      sortable: false,
      cell: (record) => record?.section2?.description || "-",
    },

    // Section 3
    {
      key: "section3.title",
      text: "Section 3 Title",
      align: "center",
      sortable: false,
      cell: (record) => record?.section3?.title || "-",
    },
    {
      key: "section3.cards",
      text: "Section 3 Cards",
      align: "center",
      sortable: false,
      cell: (record) =>
        record?.section3?.cards?.map((c) => c.title).join(", ") || "-",
    },
    // Section 4
    {
      key: "section4.title",
      text: "Section 4 Title",
      align: "center",
      sortable: false,
      cell: (record) => record?.section4?.title || "-",
    },
    {
      key: "section4.description",
      text: "Section 4 Description",
      align: "center",
      sortable: false,
      cell: (record) => record?.section4?.description || "-",
    },

    // Section 5
    {
      key: "section5.cards",
      text: "Section 5 Cards",
      align: "center",
      sortable: false,
      cell: (record) =>
        record?.section5?.cards?.map((c) => c.title).join(", ") || "-",
    },

    // Section 6
    {
      key: "section6.title",
      text: "Section 6 Title",
      align: "center",
      sortable: false,
      cell: (record) => record?.section6?.title || "-",
    },
    {
      key: "section6.description",
      text: "Section 6 Description",
      align: "center",
      sortable: false,
      cell: (record) => record?.section6?.description || "-",
    },

    // Section 7
    {
      key: "section7.cards",
      text: "Section 7 Cards",
      align: "center",
      sortable: false,
      cell: (record) =>
        record?.section7?.cards?.map((c) => c.title).join(", ") || "-",
    },


    // Section 8
    {
      key: "section8.title",
      text: "Section 8 Title",
      align: "center",
      sortable: false,
      cell: (record) => record?.section8?.title || "-",
    },
    {
      key: "section8.description",
      text: "Section 8 Description",
      align: "center",
      sortable: false,
      cell: (record) => record?.section8?.description || "-",
    },
    {
      key: "action",
      text: "Action",
      align: "center",
      sortable: false,
      cell: (record) => (
        <div className="d-flex justify-content-center align-items-center gap-2">
          <button className="cmn_plain_btn" onClick={() => handleShowEditCms(record)} >
            <img src={require("../assets/images/editer.svg").default} alt="edit" className="img-fluid table_activity_img" />
          </button>
        </div>
      ),
    }
  ];


  const config = {
    page_size: 10,
    length_menu: [10, 20, 50],
    no_data_text: "No CMS data found!",
    language: {
      length_menu: "Show _MENU_ results per page",
      pagination: { first: "First", previous: "Prev", next: "Next", last: "Last" },
    },
    show_length_menu: false,
    show_filter: false,
    show_pagination: true,
    show_info: false,
  };

  return (
    <>
      <Container fluid className="common_bg position-relative">
        <div className="liner"></div>
        <Row>
          <Col xl={2} className="p-0 d-none d-xl-block">
            <Sidebar />
          </Col>
          <Col xl={10}>
            <Header title="CMS" />
            {/* <div className="text-end mb-4">
              <button className="orange_small_primary" onClick={handleShowAddCms}>
                Add CMS
              </button>
            </div> */}

            <div className="common_page_scroller pb-5 mt-3 mt-sm-5 pe-2">
              <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                <ReactDatatable
                  config={config}
                  records={cmsList}
                  columns={columns}
                  total_record={count}
                  dynamic={true}
                  onChange={handlePagination}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      <EditCmsModal show={showEditCms} handleClose={handleCloseEditCms} record={editRecord} getCMSData={getCMSData} />
    </>
  );
};

export default Cms;
